import API from "../config/api.js";

export const InvoiceService = {
  /*     getInvoiceList(search, page=1) {
          return API.get(`api/invoices/list/se=${search}?page=${page}`);
      },
  
      getPdfInvoice(uuid) {
        return API.get(`api/invoices/pdf/${uuid}`, { responseType: 'arraybuffer' });
      },
  
      dropMember(uuid) {
        return API.post(`api/invoice/delete/${uuid}`);
      },
  
      getRevenue(filter){
        return API.get(`api/invoice/revenue-statics/${filter}`);
      },
  
      getInvoiceInfo(uuid){
        return API.get(`api/invoice/info/${uuid}`);
      },
  
      createInvoice(data) { 
        return API.post(`api/invoice/create`, data);
      },
  
      updateInvoice(uuid, data) { 
        return API.post(`api/invoice/edit/${uuid}`, data);
      },
      getProjectInvoiceList(uuid, search, page=1) {
        return API.get(`api/project/${uuid}/invoices/list/se=${search}?page=${page}`);
    }, */

  dropMember(uuid) {
    return API.delete(`api/invoice/delete/${uuid}`);
  },

  getBranches() {
    return API.get("/api/common/branches");
  },

  getCustomers() {
    return API.get("/api/common/customers");
  },

  getProducts() {
    return API.get("/api/common/products");
  },
  getPaymentMethods() {
    return API.get("/api/payment-methods/list");
  },

  getInvoiceList(search, page = 1) {
    return API.get(`api/invoice/list/se=${search}?page=${page}`);
  },

  getReceiptList(search = '') {
    const filters = encodeURIComponent(`se=${search}`);
    return API.get(`api/receipt/list/${filters}`);
  },

  getReceiptDetails(uuid) {
    return API.get(`/api/receipt/view/${uuid}`);
  },

  getInvoiceDetails(uuid) {
    return API.get(`/api/invoice/info/${uuid}`);
  },

  async getItemsByInvoiceId(Invoice_id) {
    console.log("Invoice_id in service", Invoice_id);
    try {
      const response = await API.get(`/api/invoice/info/items/${Invoice_id}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching items by Invoice number:", error);
      throw error;
    }
  },

  async createInvoice(formData) {
    try {
      const response = await API.post("/api/invoice/create", formData);
      return response.data;
    } catch (error) {
      console.error("Error creating Invoice:", error);
      throw error;
    }
  },

  async createPayment(paymentData) {
    try {
      const response = await API.post("/api/receipt/create", paymentData);
      return response.data;
    } catch (error) {
      console.error("Error creating Payment:", error);
      throw error;
    }
  },

  async updateInvoice(uuid, formData) {
    try {
      const response = await API.post(`/api/invoice/update/${uuid}`, formData);
      return response.data;
    } catch (error) {
      console.error("Error updating Invoice:", error);
      throw error;
    }
  },

  async getBatches(productId, branchId, storeId) {
    try {
      const response = await API.get(
        `/api/invoice/batches/${productId}/${branchId}/${storeId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error creating Invoice:", error);
      throw error;
    }
  },

  async getProductPricing(productId, batchId) {
    try {
      const response = await API.get(
        `/api/invoice/getProductPricing/${productId}/${batchId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error creating Invoice:", error);
      throw error;
    }
  },

  async postInvoice(uuid) {
    try {
      const response = await API.post(`/api/invoice/post/${uuid}`);
      return response.data;
    } catch (error) {
      console.error("Error post Invoice:", error);
      throw error;
    }
  },

};
